import React, { Component } from "react";
import axios from "axios";
import barcode from "../barcode.png";
import FigureCaption from "react-bootstrap/esm/FigureCaption";
import SeatNav from "./seatsnav";
import smile from "../smile.png";
let apiEndPoint =
  "https://us-central1-bkyow-22da6.cloudfunctions.net/app/details";

let secapi = "https://us-central1-bkyow-22da6.cloudfunctions.net/app/movies/";
class Payment extends Component {
  state = {};
  async componentDidMount() {
    let { data: data } = await axios.get(apiEndPoint);
    let { index, timingdata } = this.props.location.state;
    let { data: response } = await axios.get(
      secapi + index.region + "/" + index.id
    );
    console.log(index);
    console.log(response);
    if (data && response) {
      this.setState({
        paymentdata: data,
        moviedata: response,
        timingdata,
        index,
      });
    }
  }
  handleBack = () => {
    let { timingdata, index, moviedata, paymentdata } = this.state;
    console.log("inde", index.dateid);
    this.props.history.push({
      pathname:
        "/bookMovie/" +
        index.region +
        "/" +
        index.id +
        "/buyTicket/" +
        index.rid +
        "/" +
        index.selid +
        "/" +
        index.dateid,
      search: "?time=" + paymentdata.date,
      state: { vl: moviedata, val: timingdata },
    });
  };
  render() {
    let { paymentdata, moviedata, timingdata } = this.state;
    return (
      <div className="container-fluid">
        <SeatNav
          data={moviedata}
          rowdata={timingdata}
          onBack={this.handleBack}
          page="payment"
        />
        <div className="row">
          <div className="col-lg-8 border m-1">
            <img src={smile} className="m-1 col-sm-12"></img>
          </div>
          <div className="col-sm-12 col-lg-3 border m-1">
            <div className="row">
              <div className="col-12 text-danger">Booking Summary</div>
              <br />
              <br />
              <div className="col-6">Movie Name</div>
              <div className="col-6">
                {paymentdata ? paymentdata.title : ""}
              </div>
              <div className="col-6">Movie Hall</div>
              <div className="col-6">
                {paymentdata ? paymentdata.movieHall : ""}
              </div>
              <div className="col-6">Tickets</div>
              <div className="col-6">
                {paymentdata ? paymentdata.tickets.map((vl) => vl) : ""}
              </div>

              <div className="col-6">Date</div>
              <div className="col-6">{paymentdata ? paymentdata.date : ""}</div>
              <div className="col-6">Time</div>
              <div className="col-6">{paymentdata ? paymentdata.time : ""}</div>
              <div className="col-6" style={{ background: "lightyellow" }}>
                Amount Paid
              </div>
              <div className="col-6" style={{ background: "lightyellow" }}>
                RS {paymentdata ? paymentdata.amount : ""}
              </div>
            </div>
            <div>
              <img src={barcode} style={{ height: "300px" }}></img>
              <FigureCaption style={{ fontSize: "10px" }}>
                You can cancel the tickets 4 hour(s) before the show. Refunds
                will be done according to Cancellation Policy.
              </FigureCaption>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Payment;
